import React, {
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
} from "react";
import SearchIcon from "@mui/icons-material/Search";
import { Box, Button as MuiButton, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import SearchComp from "../../common/searchcomp";
import { Alert, Button, Col, Container, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import NewAlertError from "../../components/ui_comp/Alerts/views.alert.error";
import T from "../../common/traducao";
import {
  GetPermissaoEditar,
  GetPermissaoExcluir,
  GetPermissaoInserir,
  GetPermissaoVisualizar,
  getToken,
} from "../../config/localstorageConfig/localstorage";
import jwt_token from "jwt-decode";
import ListComp2 from "../../common/listcomp2";
import { ListView, ListViewHeader, ListViewInfo } from "../../common/listview";
import serviceCliente from "../../services/service.cliente";
import { PiListDashesFill } from "react-icons/pi";
import { FaRegCheckCircle } from "react-icons/fa";
import { toast } from "react-toastify";
import { BiBlock } from "react-icons/bi";
import {
  SituacaoCliente,
  getStyleSituacaoCliente,
  getStyleFiltroCliente,
  getTextColorSituacaoCliente,
} from "../../consts/situacao_cliente";
import "../../styles/botoesfiltrosrapidos.css";

const Clientes = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();
  const [clientes, setClientes] = useState();
  const [pages, setPages] = useState();
  const [records, setRecords] = useState();
  const [filterstate, setFilterState] = useState();
  const [selectedRowIndex, setSelectedRowIndex] = useState(null);
  const [IndexOrcamentoSelecionado, setIndexOrcamentoSelecionado] = useState();
  const ordertype = useRef();
  const orderField = useRef();

  const [permiteVisualizar, setPermiteVisualizar] = useState(false);
  const [permiteEditar, setPermiteEditar] = useState(false);
  const [permiteExcluir, setPermiteExcluir] = useState(false);
  const [permiteInserir, setPermiteInserir] = useState(false);

  const [redirect, setRedirect] = useState();

  const constantes = T();
  const navigate = useNavigate();

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const columns = [
    {
      field: "Id",
      headerName: "Código",
      width: 100,
      key: true,
    },
    {
      field: "RazaoSocial",
      headerName: "Nome",
      width: 150,
    },
    {
      field: "NomeFantasia",
      headerName: "Apelido",
      width: 150,
    },
    {
      field: "CPFCNPJ",
      headerName: "CNPJ / CPF",
      width: 150,
    },
    {
      field: "DataCadastro",
      headerName: "Data Cadastro",
      width: 90,
      type: "date",
      format: "dd/MM/yyyyy",
    },
    {
      field: "TipoPessoa",
      headerName: "Tipo Pessoa",
      width: 150,
    },
    {
      field: "Endereco",
      headerName: "Endereço",
      width: 150,
    },
    {
      field: "EnderecoNumero",
      headerName: "Num.",
      width: 90,
    },
    {
      field: "Municipio",
      headerName: "Munícipio",
      width: 150,
    },
    {
      field: "UF",
      headerName: "UF",
      width: 150,
    },
    {
      field: "IdVendedor",
      headerName: "Código Vendedor",
      width: 150,
    },
    {
      field: "Email",
      headerName: "Email",
      width: 150,
    },
    {
      field: "IdentidadeEstrangeiro",
      headerName: "Ident.Estrangeiro",
      align: "left",
    },
    {
      field: "Situacao",
      headerName: "Situação",
      width: 10,
      type: "custom",
      onGetCustom: (item) => {
        const style = {
          ...getStyleSituacaoCliente(item),
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          border: "none",
          fontSize: 15,
          gap: 6,
          marginLeft: 7,
        };
        return (
          <Box sx={{ width: "100%", justifyContent: "center" }}>
            <Button style={style}>
              <span>
                {item === SituacaoCliente.BLOQUEADO ? (
                  <BiBlock size={16} style={{ marginTop: -3 }} />
                ) : (
                  <FaRegCheckCircle size={16} style={{ marginTop: -3 }} />
                )}
              </span>
            </Button>
          </Box>
        );
      },
    },
  ];

  const columnsFilter = [
    {
      field: "RazaoSocial",
      headerName: "Nome",
      tipo: "text",
    },
    {
      field: "NomeFantasia",
      headerName: "Apelido",
      tipo: "text",
    },
    {
      field: "Id",
      headerName: "Código",
      tipo: "number",
    },
    {
      field: "CPFCNPJ",
      headerName: "CPF/CNPJ",
      tipo: "text",
    },
    {
      field: "municipio",
      headerName: "Município",
      tipo: "text",
    },
    {
      field: "email",
      headerName: "E-mail",
      tipo: "text",
    },
    {
      field: "Pais",
      headerName: "Ident.Estrangeiro",
      tipo: "text",
    },
  ];

  useEffect(() => {
    redirect && navigate(`/${redirect}`);
  }, [redirect]);

  useEffect(() => {
    let filter = { campo: null, operacao: null, valor: null };
    getClientes(filter);
  }, []);

  useLayoutEffect(() => {
    const token_salvo = getToken();
    if (token_salvo) {
      const token = jwt_token(token_salvo);
      let filter = { campo: null, operacao: null, valor: null };
      getClientes(filter);

      setPermiteVisualizar(GetPermissaoVisualizar("cliente"));
      setPermiteEditar(GetPermissaoEditar("cliente"));
      setPermiteExcluir(GetPermissaoExcluir("cliente"));
      setPermiteInserir(GetPermissaoInserir("cliente"));
    } else {
      setRedirect("logout");
    }
  }, []);

  function getIdCliente(index) {
    return clientes && clientes[index]?.Id;
  }

  useEffect(() => {
    const id = getIdCliente(IndexOrcamentoSelecionado);
    id && navigate(`/clientes/${id}`);
  }, [IndexOrcamentoSelecionado]);

  function getClientes(filter) {
    setError(null);
    setLoading(true);
    serviceCliente
      .getAll(filter)
      .then((response) => {
        setClientes(response.data.value);
        setPages(response.data.pages);
        setRecords(response.data.registros);
        setFilterState(filter);
      })
      .catch((error) => {
        const _error =
          error.code === "ERR_NETWORK"
            ? "Server OffLine"
            : error.response && error.response.data && error.response.data.error
              ? error.response.data.error.message
              : error.message;
        setError(_error);
        error.code === "ERR_NETWORK" && navigate("/logout");
      })
      .finally(() => {
        setLoading(false);
      });
  }

  function onSearchTitle(searchValue, searchField, serachFilter) {
    let filter = {
      situacao: null,
      campo: searchField,
      operacao: serachFilter,
      valor: searchValue,
      campoorder: orderField.current,
      tipoorder: ordertype.current,
    };
    getClientes(filter);
  }

  function getSearchView() {
    return permiteVisualizar ? (
      <SearchComp
        hasBotao={permiteInserir}
        to="/clientes/new"
        botaoDisabilitado={loading}
        title={constantes.Clientes}
        campos={columnsFilter}
        onSearch={(values) => {
          onSearchTitle(
            values.searchValue,
            values.searchField,
            values.searchoperator
          );
        }}
        renderButton={({ disabled }) => (
          <MuiButton
            type="submit"
            fullWidth
            disabled={disabled}
            startIcon={<SearchIcon />}
            sx={{
              backgroundColor: "#009180",
              color: "white",
              fontWeight: "bold",
              textTransform: "none",
              fontSize: "0.875rem",
              height: "2.3rem",
              borderRadius: "5px",
              "&:hover": { backgroundColor: "#006e62" },
              "&.Mui-disabled": { backgroundColor: "#ccc", color: "#666" },
            }}
          >
            {constantes.Buscar}
          </MuiButton>
        )}
      />
    ) : null;
  }

  function OrderChange(field, type) {
    orderField.current = field;
    ordertype.current = type;

    let filter = {
      ...filterstate,
      campoorder: field,
      tipoorder: type,
    };
    getClientes(filter);
  }

  function btnSituacaoOnClick(situacao) {
    let filter = {
      situacao: situacao,
      campo: null,
      operacao: null,
      valor: null,
      campoorder: orderField.current,
      tipoorder: ordertype.current,
    };
    getClientes(filter);
  }

  function idDetalhesCliente() {
    const clientId = getIdCliente(selectedRowIndex);
    if (!clientId) {
      toast.warn("Selecione um Cliente para ver os Detalhes");
    } else {
      navigate(`/clientes/${clientId}`);
    }
  }

  function getFilterSituacao() {
    return (
      <Container>
        <Row className="d-flex align-items-center gap-0">
          {!isMobile && (
            <Col xs={12} md="auto" className="mb-2 mb-md-0">
              <Button
                onClick={idDetalhesCliente}
                style={{
                  background: "#f8f9fa",
                  border: "1px solid #dee2e6",
                  color: "#212529",
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  whiteSpace: "nowrap",
                }}
              >
                <PiListDashesFill style={{ marginRight: "4px", flexShrink: 0 }} />
                Detalhes
              </Button>
            </Col>
          )}
          <Col xs={12} md={2}>
            <Button
              className="w-100"
              disabled={loading}
              onClick={() => btnSituacaoOnClick(SituacaoCliente.ATIVO)}
              style={{
                ...getStyleFiltroCliente(SituacaoCliente.ATIVO),
                border: "1px solid #dee2e6",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                whiteSpace: "nowrap",
              }}
            >
              <FaRegCheckCircle size={16} style={{ marginTop: -3, marginRight: 4, flexShrink: 0 }} />
              Ativos
            </Button>
          </Col>
          <Col xs={12} md={2}>
            <Button
              className="w-100"
              disabled={loading}
              onClick={() => btnSituacaoOnClick(SituacaoCliente.BLOQUEADO)}
              style={{
                ...getStyleFiltroCliente(SituacaoCliente.BLOQUEADO),
                border: "1px solid #dee2e6",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                whiteSpace: "nowrap",
              }}
            >
              <BiBlock size={16} style={{ marginTop: -3, marginRight: 4, flexShrink: 0 }} />
              Bloqueados
            </Button>
          </Col>
        </Row>
      </Container>
    );
  }

  function onPageSelect(number) {
    let filter = filterstate;
    filter.page = number;
    getClientes(filter);
  }

  function getMobileListView() {
    return (
      <ListView
        data={clientes}
        headerStyle={() => ({ background: "#ffffff" })}
        pages={pages}
        records={records}
        onPageSelect={onPageSelect}
        renderHeader={(item) => (
          <>
            <ListViewHeader
              text={item.Situacao}
              variant="body2"
              sx={{
                color: getTextColorSituacaoCliente(item.Situacao),
                fontWeight: "bold",
              }}
            />
            <ListViewHeader label="Código" text={item.Id} variant="body2" />
            <ListViewHeader
              text={item.RazaoSocial}
              sx={{ fontSize: "12px" }}
              variant="body2"
            />
          </>
        )}
        renderInfo={(item) => (
          <>
            {item.NomeFantasia && (
              <ListViewInfo label="Apelido" text={item.NomeFantasia} variant="body2" />
            )}
            <ListViewInfo label="CNPJ / CPF" text={item.CPFCNPJ} variant="body2" />
            {item.DataCadastro && (
              <ListViewInfo
                label="Data Cadastro"
                text={new Date(item.DataCadastro).toLocaleDateString("pt-BR", {
                  timeZone: "UTC",
                })}
                variant="body2"
              />
            )}
            {item.Municipio && (
              <ListViewInfo
                label="Município"
                text={item.UF ? `${item.Municipio} / ${item.UF}` : item.Municipio}
                variant="body2"
              />
            )}
            {item.Email && (
              <ListViewInfo label="E-mail" text={item.Email} variant="body2" />
            )}
          </>
        )}
        renderActions={(item) => (
          <Button
            onClick={() => navigate(`/clientes/${item.Id}`)}
            style={{
              background: "#ffffff",
              border: "1px solid #dee2e6",
              color: "#333",
              marginTop: 8,
            }}
            size="sm"
          >
            <PiListDashesFill style={{ marginBottom: "3px", marginRight: "4px" }} />
            Detalhes
          </Button>
        )}
      />
    );
  }

  function getListView() {
    if (!clientes?.length) {
      return (
        <Box
          sx={{
            display: "flex",
            width: "100%",
            height: "100%",
            justifyContent: "center",
            alignItems: "center",
            margin: "10rem 0",
          }}
        >
          <Typography
            sx={{
              fontSize: { xs: "0.8rem", sm: "1rem", md: "1rem", xl: "1.2rem" },
              color: "#919191",
              fontWeight: "bold",
              textAlign: "center",
            }}
          >
            Nenhum cliente encontrado.
          </Typography>
        </Box>
      );
    }

    if (isMobile) {
      return getMobileListView();
    }

    return (
      <>
        <ListComp2
          data={clientes}
          pages={pages}
          records={records}
          columns={columns}
          alerta={true}
          btntype={"dropdown"}
          onPageSelect={(number) => onPageSelect(number)}
          sortname={orderField.current}
          sorttype={ordertype.current}
          onSortSelect={(item, sorttype) => {
            if (sorttype === "sort") {
              OrderChange(null, null);
            } else {
              OrderChange(item, sorttype);
            }
          }}
          striped={false}
          noselect
          ativarSelectClientes={true}
          onRowClick={(index) => setSelectedRowIndex(index)}
          selectedRowIndex={IndexOrcamentoSelecionado}
        />
      </>
    );
  }

  if (!permiteVisualizar) {
    return (
      <Container>
        <Alert variant="danger">
          <Alert.Heading>{constantes.Permissao}</Alert.Heading>
          <p>{constantes.Msgsempermissao}</p>
        </Alert>
      </Container>
    );
  }

  return (
    <Container fluid className="my-3">
      <NewAlertError error={error} onClose={() => setError(null)} />
      <Container fluid className="my-3">
        {getSearchView()}
      </Container>
      <Container fluid className="my-3">
        {getFilterSituacao()}
      </Container>
      <Container fluid className="my-3">
        {getListView()}
      </Container>
    </Container>
  );
};

export default Clientes;
